import {
  useBuildingPackageId,
  useGetBuildingPackagesQuery,
  useProjectId,
  useServiceName,
} from '@consigli/hooks';
import { BuildingPackageType, ServiceName } from '@consigli/types';

import { PackageList } from './package-list';

function convertServiceNameToBuildingPackageType(serviceName: ServiceName): BuildingPackageType {
  switch (serviceName) {
    case ServiceName.CEILING_GRID:
      return BuildingPackageType.CEILING_GRID;
    case ServiceName.LOAD_CALCULATION:
      return BuildingPackageType.LOAD_CALCULATION;
    default:
      throw new Error(`Unknown ServiceName for building packages: ${serviceName}`);
  }
}

export const BuildingPackageList = () => {
  const projectId = useProjectId();
  const buildingPackageId = useBuildingPackageId();
  const serviceName = useServiceName();

  const { data: buildingPackagesResponse } = useGetBuildingPackagesQuery({
    projectId,
    type: convertServiceNameToBuildingPackageType(serviceName),
    page: 'all',
  });

  const buildingPackages = buildingPackagesResponse?.results || [];

  return <PackageList packages={buildingPackages} id={buildingPackageId} />;
};
